import kr from './translations/kr.js';
import en from './translations/en.js';
import jp from './translations/jp.js';

export default { kr, en, jp };
